import { Grid } from "@mui/material";
import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStore } from "../../../../../store";
import { OnlyPhoto } from "../../../../../../../libs/shared";



export const Siglas = ({ block }: { block?: boolean }) => {
  const siglasEPhoto = useWorkflowStore((state) => state.siglasEPhoto);
  const setSiglasEPhoto = useWorkflowStore((state) => state.setSiglasEPhoto);

  const {
    open: openSiglas,
    handleClose: handleCloseSiglas,
    handleOpen: handleOpenSiglas,
  } = useOpen();

  const fotoUrl = useBlobUrl(siglasEPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseSiglas}
        handleOpen={handleOpenSiglas}
        label="CONTENEDOR"
        open={openSiglas}
        setFoto={setSiglasEPhoto}
        width={260}
        fontSize={12}
      />
    </Grid>
  );
};
